import React from 'react'
import { observer } from 'mobx-react-lite'
import { Text } from '@mxenabled/mxui'
import { Dialog, Loader, useGlobalCopyStore, useGlobalUiStore } from '../../../common'
import { DialogProps } from '../../../common/components/dialog/Dialog'

const AddAccountModal: React.FC<DialogProps> = ({ copy, isOpen, onClose, onPrimaryAction }) => {
  const { common: commonCopy, transactions: modalCopy } = useGlobalCopyStore()
  const { isCopyLoaded } = useGlobalUiStore()

  return isCopyLoaded ? (
    <Dialog
      copy={{
        title: copy.title,
      }}
      isOpen={isOpen}
      onClose={onClose}
      onPrimaryAction={onPrimaryAction}
      primaryText={modalCopy.add_manual_account}
      secondaryText={commonCopy.cancel_button}
    >
      <Text component="p" sx={{ marginBottom: '20px' }} truncate={false}>
        {modalCopy.add_account_modal_message}
      </Text>
      <Text component="p" truncate={false}>
        {modalCopy.add_account_modal_cta}
      </Text>
    </Dialog>
  ) : (
    <Loader />
  )
}

export default observer(AddAccountModal)
